// ** Initial user ability
export const initialAbility = [
    {
        action: 'read',
        subject: 'test'
    }
]

export default initialAbility;